import Vue from 'vue';
import './assets/scss/main.scss';
import App from './App.vue';
import router from './router';
import store from './store';
import './validator';
import './utils';
import './plugins';
import './api';
import './middleware';

Vue.config.productionTip = false;
Vue.prototype.$env = process.env.NODE_ENV;
Vue.prototype.$mode = process.env.VUE_APP_MODE;

export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
